import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ITreatmentApiModel } from '@app/shared/models';
import { CustomerStopHttpService } from '@app/salon-details/services/customer-stop-form-http.service';
import { FeatherModule } from 'angular-feather';
import { inOutAnimation } from '@app/shared/utils';
import { CustomerStopForm } from '@app/salon-details/models/customer-stop-form.interface';

@Component({
  selector: 'app-customer-stop-dialog-container',
  templateUrl: './customer-stop-dialog-container.component.html',
  styleUrls: ['./customer-stop-dialog-container.component.scss'],
  standalone: true,
  animations: [inOutAnimation],
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    FeatherModule]
})
export class CustomerStopDialogContainerComponent implements OnInit {

  public activeModal = inject(NgbActiveModal);
  public formStatusOk = true;
  public formSent: boolean;
  public submitted: boolean;
  public customerStopForm: FormGroup;
  public salonId: string;
  public treatmentName: ITreatmentApiModel['name'];

  private fb = inject(FormBuilder);
  private customerStopHttpService = inject(CustomerStopHttpService);


  ngOnInit(): void {
    this.buildCustomerStopForm();
  }

  get customerNameFormControl() {
    return this.customerStopForm.controls.customerName;
  }

  get customerEmailFormControl() {
    return this.customerStopForm.controls.customerEmail;
  }

  public onCloseClick(): void {
    this.activeModal.close();
  }

  public onSubmit(): void {
    this.submitted = true;
    if (this.customerStopForm.valid) {
      const formData = this.customerStopForm.value;
      this.customerStopHttpService.submitForm(formData).subscribe(
        (response) => {
          if (response === null) {
            this.formSent = true;
          }
        },
        (error) => {
          if (error) {
            this.formStatusOk = false;
          }
        }
      );
    }
    this.customerStopForm.markAllAsTouched();
  }

  private buildCustomerStopForm(): CustomerStopForm {
    return this.customerStopForm = this.fb.group({
      salonId: [this.salonId],
      treatmentName: [this.treatmentName],
      customerEmail: ['', [Validators.required, Validators.email]],
      customerName: ['', [Validators.required]],
    });
  }
}
